export default {
    state: {
        todayList:[],
    },
    getters:{
        todayList:(state)=>state.todayList
    },
    actions: {
        async getTodayCards({rootState,commit}) {
            console.log(rootState)
            if (rootState.businessId) {
                var { data } = await this.$api.getTodayCards({
                    businessId:rootState.businessId
                });
                commit('UPDATE_TODAYLIST',data);
                return data;
            } else {
                // var { data } = await this.$api.myTodayCards();
                // return data;
            }
        }

    },
    mutations: {
        ['UPDATE_TODAYLIST'](state,payload){
            state.todayList=payload;
        }
    }
}